// decode.js

exports.decode = decode;

var DecodeBuffer = require("./decode-buffer").DecodeBuffer;

function decode(input, options) {
  var decoder = new DecodeBuffer(options);
  decoder.write(input);
  return decoder.read();
}


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/node_modules/msgpack-lite/lib/decode.js
// module id = 217
// module chunks = 0